<script setup lang="ts">
import { useAppTextsStore } from '~/stores/appTexts'

const appTexts = useAppTextsStore()
await appTexts.fetchAppTexts()
</script>

<template>
	<div id="pdf-small-layout">
		<slot />
	</div>
</template>

<style lang="scss">
@use '~/assets/css/pdf-layout-small.scss';
</style>

<style scoped>
@media print {
	header,
	footer {
		display: none !important;
	}
}

@page {
	margin: 10mm;
}

@media print {
	main {
		position: absolute;
		top: 0;
		left: 0;
		padding-bottom: 2.5rem;
	}

	.color {
		print-color-adjust: exact;
	}

	p {
		page-break-inside: avoid;
		break-inside: avoid;
	}
}
</style>
